
// FuelType services rest api calling

import { routes } from '../config/api_routes'

export const fuelTypeServices = {

    // get FuelType 
    // info: sortDesc : Boolean
    
    getFuelType: (formData) => window.axios.post(routes.getFuelTypeApi,formData),

    // add Fuel Type 

    addFuelType: (formData) => window.axios.post(routes.addFuelTypeApi,formData),

    // get FuelTypeById 

    getFuelTypeById: (formData) => window.axios.post(routes.getFuelTypeApiById,formData),

    // update FuelTypeById

    updateFuelTypeById: (formData) => window.axios.post(routes.updateFuelTypeApi,formData),

    // delete FuelTypeById

    deleteFuelTypeById: (formData) => window.axios.post(routes.deleteFuelTypeApi,formData),

    //store fuel price
    storeFuelPrice: (formData) => window.axios.post(routes.storeFuelPriceApi,formData),

    //Get fuel price
    getFuelPrice: (formData) => window.axios.post(routes.getFuelPriceApi, formData),
    getCommercialPrice: (formData) => window.axios.post(routes.getCommercialPriceApi, formData),
}